import Vue from 'vue'
import store from '@/store'

var Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } };

export default {
	namespaced: true,

	state: {
		//
	},

	getters: {
		//
	},

	mutations: {
		submit(state, payload) {
			Email.send({
				Host : "smtp.mailgun.org",
				Username : "postmaster@condominiodasamericas.com.br",
				Password : "1526125458a326d4635f037ca7abaeff-7caa9475-656384d4",
				To : "comercial@condominiodasamericas.com.br",
				From : "noreply@condominiodasamericas.com.br",
				Subject : "Contato - Site",
				Body : `
<p>Nome: <b>${payload.name}</b></p>
<p>Email: <b>${payload.email}</b></p>
<p>Telefone: <b>${payload.phone}</b></p>
<p>Mensagem: <b>${payload.message}</b></p>
				`
			}).then(
				message => {
					ga('create', 'AW-766688795', 'auto');
					ga('send', 'event', 'Contato', 'submit', 'Formulário de Contato')
				}
			)
		}
	}
}

